import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/head-solo.svg'
import _imports_1 from '../assets/head-viewpoints.svg'
import _imports_2 from '../assets/leader-types.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-b4e90e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "heatmap-viewer"
}
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "right-sidebar" }
const _hoisted_4 = { class: "sidebar-header" }
const _hoisted_5 = {
  class: "current-group-title",
  "data-test": "heatmap-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "node-tooltip" }, null, -1))
const _hoisted_7 = { class: "sidebar-controls" }
const _hoisted_8 = {
  class: "searchable-select-wrapper",
  ref: "soloViewpointsSelectWrapper"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 8L0 0h12L6 8z" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 8L0 0h12L6 8z" })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "searchable-select-group"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchable-select-group-label" }, "Default", -1))
const _hoisted_17 = ["onMousedown", "onMouseenter"]
const _hoisted_18 = {
  key: 1,
  class: "searchable-select-group"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchable-select-group-label" }, "Leader types", -1))
const _hoisted_20 = ["onMousedown", "onMouseenter"]
const _hoisted_21 = {
  key: 2,
  class: "searchable-select-group"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "searchable-select-group-label" }, "Strengths", -1))
const _hoisted_23 = ["onMousedown", "onMouseenter"]
const _hoisted_24 = {
  key: 3,
  class: "searchable-select-no-results"
}
const _hoisted_25 = { class: "sidebar-key-section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "key-title" }, "Key", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quartile-block upper-quartile-block" }, null, -1))
const _hoisted_28 = { class: "quartile-name" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quartile-block upper-mid-quartile-block" }, null, -1))
const _hoisted_30 = { class: "quartile-name" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quartile-block lower-mid-quartile-block" }, null, -1))
const _hoisted_32 = { class: "quartile-name" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quartile-block lower-quartile-block" }, null, -1))
const _hoisted_34 = { class: "quartile-name" }
const _hoisted_35 = {
  key: 0,
  class: "dimension-definition"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "9 leader types diamond"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block top3-ranking-block" }, null, -1))
const _hoisted_39 = { class: "quartile-name" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block middle3-ranking-block" }, null, -1))
const _hoisted_41 = { class: "quartile-name" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block bottom3-ranking-block" }, null, -1))
const _hoisted_43 = { class: "quartile-name" }
const _hoisted_44 = {
  key: 0,
  class: "dimension-definition"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block top10-strength-block" }, null, -1))
const _hoisted_46 = { class: "quartile-name" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block next7-strength-block" }, null, -1))
const _hoisted_48 = { class: "quartile-name" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block next7b-strength-block" }, null, -1))
const _hoisted_50 = { class: "quartile-name" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking-block bottom10-strength-block" }, null, -1))
const _hoisted_52 = { class: "quartile-name" }
const _hoisted_53 = {
  key: 0,
  class: "dimension-definition"
}

import axios from "axios";
import { debug as d } from "debug";
import ForceGraph, { ForceGraphInstance } from "force-graph";
import * as d3force from "d3-force";
import * as d3quadtree from "d3-quadtree";
import * as d3dispatch from "d3-dispatch";
import * as d3timer from "d3-timer";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import strengthItemsLegacy from "../components/smart-scratchpad/strength-items-legacy";
import leaderTypesData from "../components/smart-scratchpad/leader-types";
import { heatmapKeyDescriptions } from "./heatmap-key-descriptions";

const pieRadius = 10;
const forceDistanceFactor = 150; // For strengths similarity, 40 works
const maxLinksDisplayed = 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'heatmap-viewer',
  props: {
    id: {}
  },
  setup(__props: any) {

const d3 = { ...d3force, ...d3quadtree, ...d3dispatch, ...d3timer };
const debug = d("cs.HeatmapViewer");

// Flag to enable/disable keyboard shortcuts
const keyboardShortcutsEnabled = ref(false); // Set to true to enable shortcuts

const comparisonDimensions = [
  "Innovator",
  "Entrepreneurial",
  "Executional",
  "Practical",
  "Strategist",
  "Servant",
  "Transformational",
  "Charismatic",
  "Professional",
];

const availableDimensions = comparisonDimensions
  .map((a) => a)
  .concat([
    "Curiosity",
    "Open-minded",
    "Originality",
    "Self-belief",
    "Bravery",
    "Risk-taking",
    "Zest",
    "Optimism",
    "Appetite",
    "Resilience",
    "Perseverance",
    "Grip",
    "Consistency",
    "Fairness",
    "Ownership",
    "Humility",
    "Self-regulation",
    "Prudence",
    "Quick mind",
    "Simplifies",
    "Thinks ahead",
    "Judgement",
    "Sees opportunities",
    "Creates solutions",
    "Achievable",
    "Optimises",
    "Perspective",
    "Insightful",
    "Connects",
    "Influential",
    "Self-awareness",
    "Other awareness",
    "Manages expectations",
    "Handles conflict",
    "Sets direction",
    "Has presence",
    "Engages people",
    "Creates trust",
    "Challenges",
    "Enables others",
  ]);

const leaderTypesForHead = [
  { leaderType: "Innovator", x: 0, y: 2, colour: "#6DC8BF" },
  { leaderType: "Entrepreneurial", x: -1, y: 1, colour: "#F8C31C" },
  { leaderType: "Executional", x: -2, y: 0, colour: "#F3A123" },
  { leaderType: "Practical", x: -1, y: -1, colour: "#C0C0C0" },
  { leaderType: "Strategist", x: 0, y: -2, colour: "#823CBE" },
  { leaderType: "Servant", x: 1, y: -1, colour: "#BF1224" },
  { leaderType: "Transformational", x: 2, y: 0, colour: "#ED0B6F" },
  { leaderType: "Charismatic", x: 1, y: 1, colour: "#B0BB36" },
  { leaderType: "Professional", x: 0, y: 0, colour: "#67A6DC" },
];

const headSize = pieRadius * 0.3;
const circleSize = headSize * 1.08;
const outlineSize = headSize * 9;
const circleOffsetUnit = headSize * 1.5;
const fontSizePixels = pieRadius / 1.67;
const quartilesPalette = {
  first: "#ff4628",    // Red-Orange (Highest quartile - BEST)
  second: "#ffad00",   // Orange (Upper-mid quartile)
  third: "#4baaec",    // Light Blue (Lower-mid quartile)
  fourth: "#1a51f1",   // Blue (Lowest quartile - WORST)
};

const rankingsPalette = {
  top3: "#ff4628",     // Red-Orange - top 3 leader types (BEST)
  middle3: "#ffad00",  // Orange - middle 3 leader types
  bottom3: "#4baaec",  // Light Blue - bottom 3 leader types (WORST)
};

const strengthRankingsPalette = {
  top10: "#ff4628",    // Red-Orange - top 10 strengths (BEST)
  next7: "#ffad00",    // Orange - next 7 strengths (ranks 11-17)
  next7b: "#4baaec",   // Light Blue - next 7 strengths (ranks 18-24)
  bottom10: "#1a51f1"  // Blue - bottom 10 strengths (WORST)
};

const defaultLinkParams = { min: 0.5, max: 1.5, range: 1 };
const initialZoom = (0.015 * forceDistanceFactor) / defaultLinkParams.range; // 4;
const initialPosition = { x: 0, y: 0 };
function getWriteTextFunction(ctx, x, y, text, fontSize) {
  // We use this function to set up a closure, ensuring that parameters of the text writing are locked at invocation time
  return () => {
    ctx.fillStyle = "#000000";
    ctx.textAlign = "center";
    ctx.font = `${fontSize}px 'Nunito Sans',Helvetica,Arial,Lucida,sans-serif`;
    ctx.fillText(text, x, y + 2 * pieRadius);
  };
}

const route = useRoute();

const props = __props;

const model = ref<any | null>(null);
const parentGroupId = ref<string | null>(null);
const isDisplayingPeople = ref(false);
const isRootLevel = ref(true);
const dimensionSelected = ref("Leader type head");
const soloOrViewpoints = ref("solo");
const showPieChartKey = ref(false);
const showLeaderHeadKey = ref(false);
const showLeaderTypeRankingsKey = ref(false);
const showStrengthRankingsKey = ref(false);
const showDimensionDropdown = ref(false);
const dimensionSearchTerm = ref("");
const highlightedDimensionOption = ref("");
const showSoloViewpointsDropdown = ref(false);
const highlightedSoloViewpointsOption = ref("solo");
const topRenders = ref<any[]>([]);
const currentData = ref<any | null>(null);
const hoveredNode = ref<any | null>(null);
const groupNodesMap = ref<any | null>(null);
const graph = ref<ForceGraphInstance | null>(null);
const headerExpanded = ref(false);
// No need for reactive ref since we're using static data

const type = route.meta?.heatmapType;

const soloHeadImage = ref();
const viewpointsHeadImage = ref();
const graphRef = ref();
const dimensionSelect = ref();
const soloViewpointsSelect = ref();
const backLink = ref();
const dimensionSelectWrapper = ref();
const dimensionDropdown = ref();

// Dimension options organized by category
const dimensionOptions = {
  defaultOptions: ["Leader type head"],
  // leaderTypes: [
  //   "Innovator",
  //   "Entrepreneurial", 
  //   "Executional",
  //   "Practical",
  //   "Strategist",
  //   "Servant",
  //   "Transformational",
  //   "Charismatic",
  //   "Professional"
  // ],
  leaderTypeRankings: [
    "Innovator Rankings",
    "Entrepreneurial Rankings", 
    "Executional Rankings",
    "Practical Rankings",
    "Strategist Rankings",
    "Servant Rankings",
    "Transformational Rankings",
    "Charismatic Rankings",
    "Professional Rankings"
  ],
  // leadingIndicators: [
  //   "Sets direction",
  //   "Has presence",
  //   "Engages people",
  //   "Creates trust",
  //   "Challenges",
  //   "Enables others",
  //   "Self-awareness",
  //   "Other awareness",
  //   "Manages expectations",
  //   "Handles conflict"
  // ].sort(),
  // strengths: [
  //   "Curiosity",
  //   "Open-minded",
  //   "Originality",
  //   "Self-belief",
  //   "Bravery", 
  //   "Risk-taking",
  //   "Zest",
  //   "Optimism",
  //   "Appetite",
  //   "Resilience",
  //   "Perseverance",
  //   "Grip",
  //   "Consistency",
  //   "Fairness",
  //   "Ownership",
  //   "Humility",
  //   "Self-regulation",
  //   "Prudence",
  //   "Quick mind",
  //   "Simplifies",
  //   "Thinks ahead",
  //   "Judgement",
  //   "Sees opportunities",
  //   "Creates solutions",
  //   "Achievable",
  //   "Optimises",
  //   "Perspective",
  //   "Insightful",
  //   "Connects",
  //   "Influential",
  //   "Self-awareness",
  //   "Other awareness",
  //   "Manages expectations",
  //   "Handles conflict"
  // ].sort(),
  strengthRankings: [
    "Curiosity Rankings",
    "Open-minded Rankings",
    "Originality Rankings", 
    "Self-belief Rankings",
    "Bravery Rankings",
    "Risk-taking Rankings",
    "Zest Rankings",
    "Optimism Rankings",
    "Appetite Rankings",
    "Resilience Rankings",
    "Perseverance Rankings",
    "Grip Rankings",
    "Consistency Rankings",
    "Fairness Rankings",
    "Ownership Rankings",
    "Humility Rankings",
    "Self-regulation Rankings",
    "Prudence Rankings",
    "Quick mind Rankings",
    "Simplifies Rankings",
    "Thinks ahead Rankings",
    "Judgement Rankings",
    "Sees opportunities Rankings",
    "Creates solutions Rankings", 
    "Achievable Rankings",
    "Optimises Rankings",
    "Perspective Rankings",
    "Insightful Rankings",
    "Connects Rankings",
    "Influential Rankings",
    "Self-awareness Rankings",
    "Other awareness Rankings",
    "Manages expectations Rankings",
    "Handles conflict Rankings"
  ].sort()
};

// Computed property to filter dimension options based on search term
const filteredDimensionOptions = computed(() => {
  const searchTerm = dimensionSearchTerm.value.toLowerCase();
  
  const filtered = {
    defaultOptions: dimensionOptions.defaultOptions.filter(option => 
      option.toLowerCase().includes(searchTerm)
    ),
    // leaderTypes: dimensionOptions.leaderTypes.filter(option => 
    //   option.toLowerCase().includes(searchTerm)
    // ),
    leaderTypeRankings: dimensionOptions.leaderTypeRankings.filter(option => 
      option.toLowerCase().includes(searchTerm)
    ),
    // leadingIndicators: dimensionOptions.leadingIndicators.filter(option => 
    //   option.toLowerCase().includes(searchTerm)
    // ),
    // strengths: dimensionOptions.strengths.filter(option => 
    //   option.toLowerCase().includes(searchTerm)
    // ),
    strengthRankings: dimensionOptions.strengthRankings.filter(option => 
      option.toLowerCase().includes(searchTerm)
    )
  };
  
  return filtered;
});

// Computed property to check if there are any filtered results
const hasFilteredResults = computed(() => {
  const filtered = filteredDimensionOptions.value;
  return filtered.defaultOptions.length > 0 || 
         // filtered.leaderTypes.length > 0 || 
         filtered.leaderTypeRankings.length > 0 || 
         // filtered.leadingIndicators.length > 0 || 
         // filtered.strengths.length > 0 || 
         filtered.strengthRankings.length > 0;
});

// Get all visible options as a flat array (for keyboard navigation)
const allVisibleOptions = computed(() => {
  const filtered = filteredDimensionOptions.value;
  return [
    ...filtered.defaultOptions,
    // ...filtered.leaderTypes,
    ...filtered.leaderTypeRankings,
    // ...filtered.leadingIndicators,
    // ...filtered.strengths,
    ...filtered.strengthRankings
  ];
});

// Get the definition for the currently selected dimension
const currentDimensionDefinition = computed(() => {
  const selected = dimensionSelected.value;
  
  // Handle strength rankings specifically
  if (selected.endsWith(' Rankings') && dimensionOptions.strengthRankings.includes(selected)) {
    const strengthName = selected.replace(' Rankings', '');
    const strengthItem = strengthItemsLegacy.find(si => 
      si.name.toLowerCase() === strengthName.toLowerCase()
    );
    return strengthItem ? strengthItem.description : null;
  }
  
  // Handle leader type rankings specifically  
  if (selected.endsWith(' Rankings') && dimensionOptions.leaderTypeRankings.includes(selected)) {
    const leaderTypeName = selected.replace(' Rankings', '').toLowerCase();
    const leaderTypeKey = leaderTypeName.replace(' ', ''); // remove spaces for key lookup
    
    // Use the simple heatmap key descriptions
    return heatmapKeyDescriptions[leaderTypeKey] || null;
  }
  
  return null;
});

// Get the clean dimension name without "Rankings" suffix
const cleanDimensionName = computed(() => {
  return dimensionSelected.value.replace(' Rankings', '');
});

// Get the display name for the dimension selected (used in textbox)
const dimensionSelectedDisplay = computed(() => {
  return dimensionSelected.value.replace(' Rankings', '');
});

// Searchable dropdown functions
function onDimensionFocus(): void {
  showDimensionDropdown.value = true;
  dimensionSearchTerm.value = "";
  
  // Initialize highlighted option
  if (allVisibleOptions.value.length > 0) {
    highlightedDimensionOption.value = allVisibleOptions.value[0];
  }
}

function onDimensionSearch(event: Event): void {
  const target = event.target as HTMLInputElement;
  dimensionSearchTerm.value = target.value;
  showDimensionDropdown.value = true;
  
  // Reset highlighted option when searching
  if (allVisibleOptions.value.length > 0) {
    highlightedDimensionOption.value = allVisibleOptions.value[0];
  }
}

function selectDimension(option: string): void {
  dimensionSelected.value = option;
  dimensionSearchTerm.value = "";
  showDimensionDropdown.value = false;
  setKeys();
}

function toggleDimensionDropdown(): void {
  showDimensionDropdown.value = !showDimensionDropdown.value;
  if (showDimensionDropdown.value) {
    (dimensionSelect.value as HTMLInputElement).focus();
  }
}

function hideDimensionDropdown(): void {
  // Small delay to allow option click to register
  setTimeout(() => {
    showDimensionDropdown.value = false;
    dimensionSearchTerm.value = "";
  }, 150);
}

function handleDimensionKeydown(event: KeyboardEvent): void {
  const visibleOptions = allVisibleOptions.value;
  const currentIndex = visibleOptions.indexOf(highlightedDimensionOption.value);
  
  switch (event.code) {
    case "ArrowDown":
      event.preventDefault();
      if (currentIndex < visibleOptions.length - 1) {
        highlightedDimensionOption.value = visibleOptions[currentIndex + 1];
      }
      break;
    case "ArrowUp":
      event.preventDefault();
      if (currentIndex > 0) {
        highlightedDimensionOption.value = visibleOptions[currentIndex - 1];
      }
      break;
    case "Enter":
      event.preventDefault();
      if (highlightedDimensionOption.value) {
        selectDimension(highlightedDimensionOption.value);
      }
      break;
    case "Escape":
      event.preventDefault();
      showDimensionDropdown.value = false;
      dimensionSearchTerm.value = "";
      (dimensionSelect.value as HTMLInputElement).blur();
      break;
  }
}

// Solo/Viewpoints dropdown functions
function selectSoloViewpoints(option: string): void {
  soloOrViewpoints.value = option;
  showSoloViewpointsDropdown.value = false;
  updateOnSoloViewpointsChange();
}

function toggleSoloViewpointsDropdown(): void {
  showSoloViewpointsDropdown.value = !showSoloViewpointsDropdown.value;
  if (showSoloViewpointsDropdown.value) {
    (soloViewpointsSelect.value as HTMLInputElement).focus();
  }
}

function hideSoloViewpointsDropdown(): void {
  // Small delay to allow option click to register
  setTimeout(() => {
    showSoloViewpointsDropdown.value = false;
  }, 150);
}

function handleSoloViewpointsKeydown(event: KeyboardEvent): void {
  const options = ["solo", "viewpoints"];
  const currentIndex = options.indexOf(highlightedSoloViewpointsOption.value);
  
  switch (event.code) {
    case "ArrowDown":
      event.preventDefault();
      if (currentIndex < options.length - 1) {
        highlightedSoloViewpointsOption.value = options[currentIndex + 1];
      }
      break;
    case "ArrowUp":
      event.preventDefault();
      if (currentIndex > 0) {
        highlightedSoloViewpointsOption.value = options[currentIndex - 1];
      }
      break;
    case "Enter":
      event.preventDefault();
      if (highlightedSoloViewpointsOption.value) {
        selectSoloViewpoints(highlightedSoloViewpointsOption.value);
      }
      break;
    case "Escape":
      event.preventDefault();
      showSoloViewpointsDropdown.value = false;
      (soloViewpointsSelect.value as HTMLInputElement).blur();
      break;
  }
}

const headOutlineImages = computed(() => {
  return {
    solo: soloHeadImage.value as HTMLImageElement,
    viewpoints: viewpointsHeadImage.value as HTMLImageElement,
  };
});

function getRequiredCanvasSize(): { width: number; height: number } {
  if ((graphRef.value as HTMLElement).children.length > 0) {
    ((graphRef.value as HTMLElement).children[0] as HTMLElement).style.width = "10px";
    ((graphRef.value as HTMLElement).children[0] as HTMLElement).style.height = "10px";
  }
  return {
    width: (graphRef.value as HTMLElement).clientWidth, // window.innerWidth - 30,
    height: (graphRef.value as HTMLElement).clientHeight, // window.innerHeight - 30 - 50,
  };
}

function setKeys(): void {
  const isSelectedDimensionHead = dimensionSelected.value.endsWith(" head");
  const isSelectedDimensionRanking = dimensionSelected.value.endsWith(" Rankings");
  const isLeaderTypeRanking = isSelectedDimensionRanking && dimensionOptions.leaderTypeRankings.includes(dimensionSelected.value);
  const isStrengthRanking = isSelectedDimensionRanking && dimensionOptions.strengthRankings.includes(dimensionSelected.value);
  
  if (isSelectedDimensionHead) {
    // Show the leader head key
    showPieChartKey.value = false;
    showLeaderHeadKey.value = true;
    showLeaderTypeRankingsKey.value = false;
    showStrengthRankingsKey.value = false;
  } else if (isLeaderTypeRanking) {
    // Show the leader type rankings key
    showPieChartKey.value = false;
    showLeaderHeadKey.value = false;
    showLeaderTypeRankingsKey.value = true;
    showStrengthRankingsKey.value = false;
  } else if (isStrengthRanking) {
    // Show the strength rankings key
    showPieChartKey.value = false;
    showLeaderHeadKey.value = false;
    showLeaderTypeRankingsKey.value = false;
    showStrengthRankingsKey.value = true;
  } else {
    // Show the quartiles key
    showPieChartKey.value = true;
    showLeaderHeadKey.value = false;
    showLeaderTypeRankingsKey.value = false;
    showStrengthRankingsKey.value = false;
  }
}

function getData(): any {
  if (!parentGroupId.value) {
    isDisplayingPeople.value = false;
    isRootLevel.value = true;
    setKeys();
    return {
      nodes: model.value.groupNodes.filter(
        (n) =>
          n.level === 0 &&
          n.data &&
          n.data[soloOrViewpoints.value] &&
          Object.keys(n.data[soloOrViewpoints.value]).length > 0,
      ),
      links: model.value.groupLinks.filter((l) => l.level === 0),
    };
  }

  isRootLevel.value = false;

  const groupNodesForDisplay = model.value.groupNodes.filter(
    (n) =>
      n.parentId === parentGroupId.value &&
      n.data &&
      n.data[soloOrViewpoints.value] &&
      Object.keys(n.data[soloOrViewpoints.value]).length > 0,
  );

  const groupIdsForDisplay = groupNodesForDisplay.map((g) => g.id || g.groupId);

  const groupData = {
    nodes: groupNodesForDisplay,
    links: model.value.groupLinks.filter(
      (l) =>
        l.parentId === parentGroupId.value &&
        ((typeof l.source === "string" &&
          groupIdsForDisplay.includes(l.source) &&
          groupIdsForDisplay.includes(l.target)) ||
          (groupIdsForDisplay.includes(l.source.id) && groupIdsForDisplay.includes(l.target.id))),
    ),
  };

  if (groupData.nodes.length > 0) {
    isDisplayingPeople.value = false;
    setKeys();
    return groupData;
  }

  isDisplayingPeople.value = true;

  const peopleNodesForDisplay = model.value.peopleNodes.filter(
    (n) =>
      n.groupId === parentGroupId.value &&
      n.data &&
      n.data[soloOrViewpoints.value] &&
      Object.keys(n.data[soloOrViewpoints.value]).length > 0,
  );

  const peopleIdsForDisplay = peopleNodesForDisplay.map((p) => p.id);
  setKeys();
  return {
    nodes: peopleNodesForDisplay,
    links: model.value.peopleLinks.filter(
      (l) =>
        l.groupId === parentGroupId.value &&
        ((typeof l.source === "string" &&
          peopleIdsForDisplay.includes(l.source) &&
          peopleIdsForDisplay.includes(l.target)) ||
          (peopleIdsForDisplay.includes(l.source.id) && peopleIdsForDisplay.includes(l.target.id))),
    ),
  };
}

function goUp(): void {
  if (parentGroupId.value) {
    const parentGroup = groupNodesMap.value[parentGroupId.value];
    parentGroupId.value = parentGroup.parentId;
    const newData = getData();
    currentData.value = newData;
    graph.value
      .graphData(currentData.value)
      .d3Force(
        "link",
        d3.forceLink().distance((l) => l.distance[soloOrViewpoints.value] * forceDistanceFactor),
      )
      .linkVisibility(true) // isDisplayingPeople && newData.nodes.length < maxLinksDisplayed)
      .centerAt(initialPosition.x, initialPosition.y)
      .zoom(isRootLevel.value ? initialZoom * 2 : initialZoom);
    // document.getElementById("current-group-title").textContent = parentGroupId ? groupNodesMap[parentGroupId].name : heatmapData.name;
    // const backLink = document.getElementById("back-link");
    // if (isRootLevel) {
    //     backLink.classList.add("hidden");
    // } else {
    //     backLink.classList.remove("hidden");
    // }
  }
}

function updateOnSoloViewpointsChange(): void {
  const newData = getData();
  currentData.value = newData;
  graph.value
    .graphData(currentData.value)
    .d3Force(
      "link",
      d3.forceLink().distance((l) => l.distance[soloOrViewpoints.value] * forceDistanceFactor),
    )
    .linkVisibility(true)
    .centerAt(initialPosition.x, initialPosition.y)
    .zoom(isRootLevel.value ? initialZoom * 2 : initialZoom);
}

function getFillColourForData(dataForDimension: {
  IsFirstQuartile: boolean;
  IsSecondQuartile: boolean;
  IsThirdQuartile: boolean;
  IsFourthQuartile: boolean;
}): string {
  if (dataForDimension.IsFirstQuartile) {
    return quartilesPalette.first;
  }

  if (dataForDimension.IsSecondQuartile) {
    return quartilesPalette.second;
  }

  if (dataForDimension.IsThirdQuartile) {
    return quartilesPalette.third;
  }

  return quartilesPalette.fourth;
}

function getFillColourForRankingData(dataForDimension: {
  IsInTop3LeaderTypes?: boolean;
  IsInMiddle3LeaderTypes?: boolean;
  IsInBottom3LeaderTypes?: boolean;
  IsInTop10Strengths?: boolean;
  IsIn10To17Strengths?: boolean;
  IsIn17To24Strengths?: boolean;
  IsInBottom10Strengths?: boolean;
}): string {
  // Handle leader type rankings
  if (dataForDimension.IsInTop3LeaderTypes) {
    return rankingsPalette.top3;
  }

  if (dataForDimension.IsInMiddle3LeaderTypes) {
    return rankingsPalette.middle3;
  }

  if (dataForDimension.IsInBottom3LeaderTypes) {
    return rankingsPalette.bottom3;
  }

  // Handle strength rankings
  if (dataForDimension.IsInTop10Strengths) {
    return strengthRankingsPalette.top10;
  }

  if (dataForDimension.IsIn10To17Strengths) {
    return strengthRankingsPalette.next7;
  }

  if (dataForDimension.IsIn17To24Strengths) {
    return strengthRankingsPalette.next7b;
  }

  if (dataForDimension.IsInBottom10Strengths) {
    return strengthRankingsPalette.bottom10;
  }

  // Default to a neutral color if no ranking data
  return "#CCCCCC";
}

function drawNodeWithPie(node: any, ctx: any): void {
  const { id } = node;
  const { x } = node;
  const { y } = node;
  const { name } = node;
  const { data } = node;

  // Handle ranking dimensions (both leader types and strengths)
  const isRankingDimension = dimensionSelected.value.endsWith(" Rankings");
  const isLeaderTypeRanking = isRankingDimension && dimensionOptions.leaderTypeRankings.includes(dimensionSelected.value);
  const isStrengthRanking = isRankingDimension && dimensionOptions.strengthRankings.includes(dimensionSelected.value);
  let dimensionKey = dimensionSelected.value;
  
  if (isRankingDimension) {
    // Extract the name from "X Rankings" format
    dimensionKey = dimensionSelected.value.replace(" Rankings", "");
  }

  if (!data[soloOrViewpoints.value].quartiles[dimensionKey]) {
    return;
  }

  ctx.strokeStyle = "#ffffff";
  ctx.lineWidth = pieRadius / 12.5;
  ctx.lineJoin = "round";

  if (!isDisplayingPeople.value) {
    // Draw a white outer circle
    ctx.beginPath();
    ctx.fillStyle = "#ffffff";
    ctx.arc(x, y, pieRadius * 1.2, 0, 2 * Math.PI);
    ctx.fill();

    // Draw the pie chart based on the data
    const initialAngle = 1.5 * Math.PI;
    let angle = initialAngle;

    if (isLeaderTypeRanking) {
      // Draw leader type ranking pie chart (Top 3, Middle 3, Bottom 3)
      const quarterData = data[soloOrViewpoints.value].quartiles[dimensionKey];
      
      // Top 3
      const top3Value = quarterData.Top3LeaderTypes || 0;
      if (top3Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = rankingsPalette.top3;
        ctx.arc(x, y, pieRadius, angle, angle + 2 * Math.PI * top3Value);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        angle += 2 * Math.PI * top3Value;
      }

      // Middle 3
      const middle3Value = quarterData.Middle3LeaderTypes || 0;
      if (middle3Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = rankingsPalette.middle3;
        ctx.arc(x, y, pieRadius, angle, angle + 2 * Math.PI * middle3Value);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        angle += 2 * Math.PI * middle3Value;
      }

      // Bottom 3
      const bottom3Value = quarterData.Bottom3LeaderTypes || 0;
      if (bottom3Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = rankingsPalette.bottom3;
        ctx.arc(x, y, pieRadius, angle, initialAngle + 2 * Math.PI);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
      }
    } else if (isStrengthRanking) {
      // Draw strength ranking pie chart (Top 10, Next 7, Next 7, Bottom 10)
      const quarterData = data[soloOrViewpoints.value].quartiles[dimensionKey];
      
      // Top 10
      const top10Value = quarterData.Top10Strengths || 0;
      if (top10Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = strengthRankingsPalette.top10;
        ctx.arc(x, y, pieRadius, angle, angle + 2 * Math.PI * top10Value);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        angle += 2 * Math.PI * top10Value;
      }

      // Next 7 (10-16)
      const next7Value = quarterData.Strengths10To17 || 0;
      if (next7Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = strengthRankingsPalette.next7;
        ctx.arc(x, y, pieRadius, angle, angle + 2 * Math.PI * next7Value);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        angle += 2 * Math.PI * next7Value;
      }

      // Next 7 (17-23)
      const next7bValue = quarterData.Strengths17To24 || 0;
      if (next7bValue > 0) {
        ctx.beginPath();
        ctx.fillStyle = strengthRankingsPalette.next7b;
        ctx.arc(x, y, pieRadius, angle, angle + 2 * Math.PI * next7bValue);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        angle += 2 * Math.PI * next7bValue;
      }

      // Bottom 10
      const bottom10Value = quarterData.Bottom10Strengths || 0;
      if (bottom10Value > 0) {
        ctx.beginPath();
        ctx.fillStyle = strengthRankingsPalette.bottom10;
        ctx.arc(x, y, pieRadius, angle, initialAngle + 2 * Math.PI);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
      }
    } else {
      // Draw standard quartile pie chart
      // First quartile
      ctx.beginPath();
      ctx.fillStyle = quartilesPalette.first;
      ctx.arc(
        x,
        y,
        pieRadius,
        angle,
        angle + 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].FirstQuartile,
      );
      ctx.lineTo(x, y);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      angle += 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].FirstQuartile;

      // Second quartile
      ctx.beginPath();
      ctx.fillStyle = quartilesPalette.second;
      ctx.arc(
        x,
        y,
        pieRadius,
        angle,
        angle + 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].SecondQuartile,
      );
      ctx.lineTo(x, y);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      angle += 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].SecondQuartile;

      // Third quartile
      ctx.beginPath();
      ctx.fillStyle = quartilesPalette.third;
      ctx.arc(
        x,
        y,
        pieRadius,
        angle,
        angle + 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].ThirdQuartile,
      );
      ctx.lineTo(x, y);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
      angle += 2 * Math.PI * data[soloOrViewpoints.value].quartiles[dimensionKey].ThirdQuartile;

      // Fourth quartile
      ctx.beginPath();
      ctx.fillStyle = quartilesPalette.fourth;
      ctx.arc(x, y, pieRadius, angle, initialAngle + 2 * Math.PI);
      ctx.lineTo(x, y);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    }

    // Text label
    topRenders.value.push(getWriteTextFunction(ctx, x, y, name, fontSizePixels));
  } else {
    // Draw a white outer circle
    ctx.beginPath();
    ctx.fillStyle = "#ffffff";
    ctx.arc(x, y, pieRadius * 1.2, 0, 2 * Math.PI);
    ctx.fill();

    // Draw a circle in a colour based on the data
    const dataForDimension = data[soloOrViewpoints.value].quartiles[dimensionKey];
    ctx.beginPath();
    
    if (isRankingDimension) {
      ctx.fillStyle = getFillColourForRankingData(dataForDimension);
    } else {
      ctx.fillStyle = getFillColourForData(dataForDimension);
    }
    
    ctx.arc(x, y, pieRadius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    // Text label
    topRenders.value.push(getWriteTextFunction(ctx, x, y, name, fontSizePixels));
  }
}

function removeGroupFromData(groupId: string): void {
  delete groupNodesMap.value[groupId];
  const index = model.value.groupNodes.findIndex((g) => g.id === groupId);
  if (index !== -1) {
    model.value.groupNodes.splice(index, 1);
  }
}

function drawNodeWithHead(node, ctx) {
  const { id } = node;
  const { x } = node;
  const { y } = node;
  const { name } = node;
  const { data } = node;

  // Draw the head outline
  ctx.imageSmoothingEnabled = true;
  ctx.drawImage(
    headOutlineImages.value[soloOrViewpoints.value],
    x - outlineSize / 2 + outlineSize * 0.03,
    y - (outlineSize * (289 / 217)) / 2 + outlineSize * 0.15,
    outlineSize,
    outlineSize * (289 / 217),
  );

  // Draw the grid lines
  ctx.strokeStyle = "rgba(0,0,0,.12)";
  ctx.lineWidth = 0.3;
  ctx.beginPath();
  // Horizontal
  ctx.moveTo(x - headSize * 1.5, y);
  ctx.lineTo(x + headSize * 1.5, y);
  ctx.stroke();
  // Vertical
  ctx.moveTo(x, y - headSize * 1.5);
  ctx.lineTo(x, y + headSize * 1.5);
  ctx.stroke();

  // Draw the 9 circles
  const originalAlpha = ctx.globalAlpha;
  ctx.globalAlpha = originalAlpha * 0.9;
  ctx.lineWidth = 0;
  leaderTypesForHead.forEach((l) => {
    const fit = Math.max(3, data[soloOrViewpoints.value].leaderFits[l.leaderType]);
    ctx.beginPath();
    ctx.fillStyle = l.colour;
    if (soloOrViewpoints.value === "solo") {
      // Circles
      ctx.arc(x + l.x * headSize, y - l.y * headSize, circleSize * (fit / 100), 0, 2 * Math.PI);
    } else {
      // Diamonds
      const diamondSize = circleSize * (fit / 100) * 1.5;
      ctx.moveTo(x + l.x * headSize - diamondSize, y - l.y * headSize);
      ctx.lineTo(x + l.x * headSize, y - l.y * headSize - diamondSize);
      ctx.lineTo(x + l.x * headSize + diamondSize, y - l.y * headSize);
      ctx.lineTo(x + l.x * headSize, y - l.y * headSize + diamondSize);
      ctx.closePath();
    }
    ctx.fill();
  });
  ctx.globalAlpha = originalAlpha;

  // Text label
  topRenders.value.push(getWriteTextFunction(ctx, x, y, name, fontSizePixels));
}

function initialize(heatmapData: any) {
  // Dimensions for similarity comparison

  // Add the element to the body
  // We do this so that the same approach can be used in KNIME, where we don't have access to the HTML, only javascript.
  // var body = document.getElementsByTagName('body')[0];
  // body.innerHTML += '<div id="graph"></div>';
  document.title = `Gyre - ${heatmapData.name}`;
  // document.getElementById("current-group-title").textContent = heatmapData.name;

  groupNodesMap.value = heatmapData.groupNodes.reduce((obj, val) => {
    obj[val.id] = val;
    return obj;
  }, {});

  heatmapData.linkParams = defaultLinkParams; // { min: 0.5, max: 1.5, range: 1 };
  currentData.value = getData();
  const graphElement = graphRef.value as any;
  const graphSize = getRequiredCanvasSize();
  // (document.getElementById('graph'))

  graph.value = (ForceGraph()(graphElement) as any)
    .nodeCanvasObject((node, ctx) => {
      if (dimensionSelected.value.endsWith(" head")) {
        drawNodeWithHead(node, ctx);
      } else {
        drawNodeWithPie(node, ctx);
      }
      //  if node has no quartiles do not render anything
      if (topRenders.value.length === 0) {
        currentData.value.nodes = [];
        currentData.value.links = [];
        return;
      }
      // If we're the last node, render anything that we deferred (to end up on top), e.g. text
      if (
        currentData.value.nodes.length > 0 &&
        node === currentData.value.nodes[currentData.value.nodes.length - 1]
      ) {
        topRenders.value.forEach((fcn: () => any) => fcn());
        topRenders.value = [];
      }
    })
    .nodeLabel((n) => n.name)
    .linkLabel(null) // .linkLabel('distance')
    .linkColor((l) => "#0000001f")
    .linkVisibility(true)
    // .cooldownTime(Infinity)
    // .warmupTicks(600)
    .d3AlphaDecay(0.05) // Default: 0.0228
    // .d3VelocityDecay(0.4) // Default: 0.4
    .nodeRelSize(pieRadius * 1.2)
    // Deactivate existing forces
    // .d3Force('center', null)
    .d3Force("charge", null)
    .width(graphSize.width)
    .height(graphSize.height)
    .enableNodeDrag(false)
    .d3Force(
      "link",
      d3.forceLink().distance((l) => l.distance[soloOrViewpoints.value] * forceDistanceFactor),
    )
    .onNodeClick((n) => {
      if (!isDisplayingPeople.value) {
        parentGroupId.value = n.id;
        const newData = getData();
        if (newData.nodes.length > 0) {
          currentData.value = newData;
          graph.value
            .graphData(currentData.value)
            .d3Force(
              "link",
              d3
                .forceLink()
                .distance((l) => l.distance[soloOrViewpoints.value] * forceDistanceFactor),
            )
            .linkVisibility(true)
            .centerAt(initialPosition.x, initialPosition.y)
            .zoom(isRootLevel.value ? initialZoom * 2 : initialZoom);
        }
      }
    })
    .onNodeHover((n) => {
      hoveredNode.value = n;
    })
    // .onBackgroundClick((e) => {})
    .graphData(currentData.value)
    .centerAt(initialPosition.x, initialPosition.y)
    .zoom(initialZoom * 2);

  graphElement.addEventListener("mousemove", (evt) => {
    const tooltip = document.getElementsByClassName("graph-tooltip")[0] as HTMLElement;

    if (hoveredNode.value) {
      if (dimensionSelected.value.endsWith(" head")) {
        const graphCoords = graph.value.screen2GraphCoords(evt.offsetX, evt.offsetY);
        const hit = leaderTypesForHead
          .map((l) => {
            // TODO: Use a circle instead of a square
            const leaderFit =
              hoveredNode.value.data[soloOrViewpoints.value].leaderFits[l.leaderType];
            const fitCircleSize = (circleSize * leaderFit) / 100;
            if (
              Math.abs(graphCoords.x - hoveredNode.value.x - l.x * headSize) < fitCircleSize &&
              Math.abs(graphCoords.y - hoveredNode.value.y + l.y * headSize) < fitCircleSize
            ) {
              return { leaderType: l.leaderType, fit: leaderFit };
            }
            return undefined;
          })
          .filter((l) => l)
          .find((l) => true);
        if (hit) {
          tooltip.textContent = `${hit.leaderType}: ${hit.fit}% fit`;
          tooltip.style.display = "block";
          return;
        }
      }
    }
    tooltip.style.display = "none";
  });

  // TODO: Clean up window event handlers
  window.onresize = () => {
    const newGraphSize = getRequiredCanvasSize();
    graph.value.width(newGraphSize.width).height(newGraphSize.height);
  };

  window.onkeydown = (ev) => {
    // Early return to disable all shortcuts
    if (!keyboardShortcutsEnabled.value) {
      return;
    }
    
    const dimensionInputEl = dimensionSelect.value as HTMLInputElement;
    const soloViewpointsInputEl = soloViewpointsSelect.value as HTMLInputElement;
    
    // Don't interfere with typing in input fields
    const isTypingInDimensionSearch = document.activeElement === dimensionInputEl;
    const isTypingInSoloViewpoints = document.activeElement === soloViewpointsInputEl;
    
    if (ev.code === "KeyB") {
      goUp();
      ev.preventDefault(); // Prevent the event from continuing (for example, to select in the drop-down)
    } else if (ev.code === "KeyD" && !isTypingInDimensionSearch) {
      // Focus the dimension search input
      dimensionInputEl.focus();
      ev.preventDefault();
    } else if (ev.code === "KeyZ" && !isTypingInDimensionSearch) {
      // Cycle to next dimension
      const allOptions = allVisibleOptions.value;
      const currentIndex = allOptions.indexOf(dimensionSelected.value);
      if (currentIndex < allOptions.length - 1) {
        selectDimension(allOptions[currentIndex + 1]);
      }
      ev.preventDefault();
    } else if (ev.code === "KeyA" && !isTypingInDimensionSearch) {
      // Cycle to previous dimension
      const allOptions = allVisibleOptions.value;
      const currentIndex = allOptions.indexOf(dimensionSelected.value);
      if (currentIndex > 0) {
        selectDimension(allOptions[currentIndex - 1]);
      }
      ev.preventDefault();
    } else if (ev.code === "KeyS" && !isTypingInDimensionSearch && !isTypingInSoloViewpoints && soloOrViewpoints.value !== "solo") {
      selectSoloViewpoints("solo");
      ev.preventDefault();
    } else if (ev.code === "KeyV" && !isTypingInDimensionSearch && !isTypingInSoloViewpoints && soloOrViewpoints.value !== "viewpoints") {
      selectSoloViewpoints("viewpoints");
      ev.preventDefault();
    } else if (ev.code === "Delete" && !isTypingInDimensionSearch && parentGroupId.value !== null) {
      const idOfGroupToRemove = parentGroupId.value;
      goUp();
      removeGroupFromData(idOfGroupToRemove);
      updateOnSoloViewpointsChange();
    }
  };





  (backLink.value as HTMLElement).onclick = (event) => {
    goUp();
  };
}

onMounted(() => {
  // Load heatmap data
  axios.get(`/api/heatmap/${type}/?id=${props.id}`).then((resp) => {
    model.value = resp.data;
    debug(model.value);
    // Delay to allow the refs to be initialized
    setTimeout(() => {
      initialize(model.value);
    }, 0);
  });
  
  // Definitions use hardcoded data from strengthItemsLegacy and leaderTypesData
});

return (_ctx: any,_cache: any) => {
  return (model.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          ref_key: "soloHeadImage",
          ref: soloHeadImage,
          class: "hidden",
          src: _imports_0,
          alt: "head outline with plotted circles"
        }, null, 512),
        _createElementVNode("img", {
          ref_key: "viewpointsHeadImage",
          ref: viewpointsHeadImage,
          class: "hidden",
          src: _imports_1,
          alt: "head outline with plotted diamonds"
        }, null, 512),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "graph",
            ref_key: "graphRef",
            ref: graphRef
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(parentGroupId.value ? groupNodesMap.value[parentGroupId.value].name : model.value.name), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              ref_key: "backLink",
              ref: backLink,
              class: _normalizeClass(["back-link", { hidden: isRootLevel.value }]),
              href: "javascript:void(0)",
              "data-test": "heatmap-back-button"
            }, "Go up a level", 2),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("input", {
                type: "text",
                class: "searchable-select-input",
                ref_key: "soloViewpointsSelect",
                ref: soloViewpointsSelect,
                value: soloOrViewpoints.value === 'solo' ? 'Solo' : 'Viewpoints',
                onFocus: _cache[0] || (_cache[0] = ($event: any) => (showSoloViewpointsDropdown.value = true)),
                onBlur: hideSoloViewpointsDropdown,
                onKeydown: handleSoloViewpointsKeydown,
                readonly: "",
                "data-test": "heatmap-soloviewpoints-dropdown"
              }, null, 40, _hoisted_9),
              _createElementVNode("div", {
                class: "searchable-select-arrow",
                onClick: toggleSoloViewpointsDropdown
              }, _hoisted_11),
              _createElementVNode("div", {
                class: _normalizeClass(["searchable-select-dropdown", { visible: showSoloViewpointsDropdown.value }]),
                ref: "soloViewpointsDropdown"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["searchable-select-option", { selected: soloOrViewpoints.value === 'solo', highlighted: highlightedSoloViewpointsOption.value === 'solo' }]),
                  onMousedown: _cache[1] || (_cache[1] = ($event: any) => (selectSoloViewpoints('solo'))),
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (highlightedSoloViewpointsOption.value = 'solo'))
                }, " Solo ", 34),
                _createElementVNode("div", {
                  class: _normalizeClass(["searchable-select-option", { selected: soloOrViewpoints.value === 'viewpoints', highlighted: highlightedSoloViewpointsOption.value === 'viewpoints' }]),
                  onMousedown: _cache[3] || (_cache[3] = ($event: any) => (selectSoloViewpoints('viewpoints'))),
                  onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (highlightedSoloViewpointsOption.value = 'viewpoints'))
                }, " Viewpoints ", 34)
              ], 2)
            ], 512),
            _createElementVNode("div", {
              class: "searchable-select-wrapper",
              ref_key: "dimensionSelectWrapper",
              ref: dimensionSelectWrapper
            }, [
              _createElementVNode("input", {
                type: "text",
                class: "searchable-select-input",
                ref_key: "dimensionSelect",
                ref: dimensionSelect,
                value: showDimensionDropdown.value ? dimensionSearchTerm.value : dimensionSelectedDisplay.value,
                onInput: onDimensionSearch,
                onFocus: onDimensionFocus,
                onBlur: hideDimensionDropdown,
                onKeydown: handleDimensionKeydown,
                placeholder: "Search dimensions...",
                "data-test": "heatmap-dimensions-dropdown"
              }, null, 40, _hoisted_12),
              _createElementVNode("div", {
                class: "searchable-select-arrow",
                onClick: toggleDimensionDropdown
              }, _hoisted_14),
              _createElementVNode("div", {
                class: _normalizeClass(["searchable-select-dropdown", { visible: showDimensionDropdown.value }]),
                ref_key: "dimensionDropdown",
                ref: dimensionDropdown
              }, [
                (filteredDimensionOptions.value.defaultOptions.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDimensionOptions.value.defaultOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: option,
                          class: _normalizeClass(["searchable-select-option", { selected: option === dimensionSelected.value, highlighted: option === highlightedDimensionOption.value }]),
                          onMousedown: ($event: any) => (selectDimension(option)),
                          onMouseenter: ($event: any) => (highlightedDimensionOption.value = option)
                        }, _toDisplayString(option), 43, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (filteredDimensionOptions.value.leaderTypeRankings.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDimensionOptions.value.leaderTypeRankings, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: option,
                          class: _normalizeClass(["searchable-select-option", { selected: option === dimensionSelected.value, highlighted: option === highlightedDimensionOption.value }]),
                          onMousedown: ($event: any) => (selectDimension(option)),
                          onMouseenter: ($event: any) => (highlightedDimensionOption.value = option)
                        }, _toDisplayString(option.replace(' Rankings', '')), 43, _hoisted_20))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (filteredDimensionOptions.value.strengthRankings.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDimensionOptions.value.strengthRankings, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: option,
                          class: _normalizeClass(["searchable-select-option", { selected: option === dimensionSelected.value, highlighted: option === highlightedDimensionOption.value }]),
                          onMousedown: ($event: any) => (selectDimension(option)),
                          onMouseenter: ($event: any) => (highlightedDimensionOption.value = option)
                        }, _toDisplayString(option.replace(' Rankings', '')), 43, _hoisted_23))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!hasFilteredResults.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No results found "))
                  : _createCommentVNode("", true)
              ], 2)
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", {
              class: _normalizeClass(["pie-chart-key", { hidden: !showPieChartKey.value }]),
              "data-test": "heatmap-piechart-key"
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _hoisted_27,
                  _createTextVNode(" upper quartile "),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_29,
                  _createTextVNode(" upper-mid quartile "),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_31,
                  _createTextVNode(" lower-mid quartile "),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_33,
                  _createTextVNode(" lower quartile "),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(cleanDimensionName.value), 1)
                ])
              ]),
              (currentDimensionDefinition.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("p", null, _toDisplayString(currentDimensionDefinition.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["leader-head-key", { hidden: !showLeaderHeadKey.value }]),
              "data-test": "heatmap-head-key"
            }, _hoisted_37, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["leader-type-rankings-key", { hidden: !showLeaderTypeRankingsKey.value }]),
              "data-test": "heatmap-rankings-key"
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _hoisted_38,
                  _createTextVNode(" Best-fit Leader type "),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_40,
                  _createTextVNode(" Mid-fit Leader type "),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_42,
                  _createTextVNode(" Least-fit Leader type "),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(cleanDimensionName.value), 1)
                ])
              ]),
              (currentDimensionDefinition.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("p", null, _toDisplayString(currentDimensionDefinition.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["strength-rankings-key", { hidden: !showStrengthRankingsKey.value }]),
              "data-test": "heatmap-strength-rankings-key"
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _hoisted_45,
                  _createTextVNode(" Top 10 Strengths "),
                  _createElementVNode("span", _hoisted_46, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_47,
                  _createTextVNode(" Bubbling under Strengths "),
                  _createElementVNode("span", _hoisted_48, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_49,
                  _createTextVNode(" Background Strengths "),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(cleanDimensionName.value), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_51,
                  _createTextVNode(" Bottom 10 Strengths "),
                  _createElementVNode("span", _hoisted_52, _toDisplayString(cleanDimensionName.value), 1)
                ])
              ]),
              (currentDimensionDefinition.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("p", null, _toDisplayString(currentDimensionDefinition.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})